<style lang="less">
@import "./main.less";
</style>
<template>
  <div class="main" :class="{ 'main-hide-text': shrink }">
    <div>
      <Modal
        v-model="isResetPwd"
        :mask-closable="false"
        :closable="false"
        title="修改密码"
      >
        <div slot="footer">
          <Button size="large" @click="onResetPwdModalCancel">取消</Button>
          <Button type="primary" size="large" @click="onResetPwdModalOk"
            >确定</Button
          >
        </div>
        <Form
          ref="form"
          :model="userInfo"
          :rules="ruleInline"
          :label-width="80"
        >
          <FormItem prop="oldPassword" label="原密码" class="inputItem">
            <Input
              type="password"
              v-model="userInfo.oldPassword"
              placeholder="请输入原密码"
            />
          </FormItem>
          <FormItem prop="newPassword" label="新密码" class="inputItem">
            <Input
              type="password"
              v-model="userInfo.newPassword"
              placeholder="请输入新密码"
            />
          </FormItem>
          <FormItem prop="confirmPassword" label="确认新密码" class="inputItem">
            <Input
              type="password"
              v-model="userInfo.confirmPassword"
              placeholder="请确认新密码"
            />
          </FormItem>
        </Form>
      </Modal>
    </div>
    <!-- :style="{paddingLeft: shrink?'60px':'200px'}" -->
    <div class="main-header-con">
      <div class="main-header">
        <div class="header-left">
          <div class="navicon-con">
            <Button
              :style="{
                transform: 'rotateZ(' + (this.shrink ? '-90' : '0') + 'deg)',
              }"
              type="text"
              @click="toggleClick"
            >
              <Icon type="md-menu" size="32"></Icon>
            </Button>
          </div>
          <div class="main-title">垃圾分类智能考核云监管平台</div>
          <!-- <div class="header-middle-con">
            <div class="main-breadcrumb">
              <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
            </div>
          </div> -->
        </div>
        <div class="header-avator-con">
          <!--<full-screen v-model="isFullScreen" @on-change="fullscreenChange"></full-screen>-->
          <!--<lock-screen></lock-screen>-->
          <!--<message-tip v-model="mesCount"></message-tip>-->
          <!--<theme-switch></theme-switch>-->

          <div class="user-dropdown-menu-con">
            <Row
              type="flex"
              justify="end"
              align="middle"
              class="user-dropdown-innercon"
            >
              <Avatar
                :src="avatorPath"
                style="background: #619fe7; margin: 0 8px"
              ></Avatar>
              <Dropdown
                transfer
                trigger="click"
                @on-click="handleClickUserDropdown"
              >
                <a href="javascript:void(0)">
                  <span class="main-user-name">{{ userName }}</span>
                  <Icon type="md-arrow-dropdown" />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem name="resetPwd">修改密码</DropdownItem>
                  <DropdownItem name="loginout">退出登录</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Row>
          </div>
        </div>
      </div>
    </div>

    <div
      class="sidebar-menu-con"
      :style="{
        width: shrink ? '60px' : '200px',
        overflow: shrink ? 'visible' : 'auto',
      }"
    >
      <shrinkable-menu
        :shrink="shrink"
        @on-change="handleSubmenuChange"
        :theme="menuTheme"
        :before-push="beforePush"
        :open-names="openedSubmenuArr"
        :menu-list="menuList"
      >
      </shrinkable-menu>
    </div>

    <div class="single-page-con" :style="{paddingLeft: shrink?'60px':'200px'}">
      <div class="tags-con"   v-show="true">
        <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
      </div>
      <div class="single-page">
        <keep-alive :include="cachePage">
          <router-view></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>
<script >
  import shrinkableMenu from '../components/main-components/shrinkable-menu/shrinkable-menu.vue';
  import tagsPageOpened from '../components/main-components/tags-page-opened.vue';
  import breadcrumbNav from '../components/main-components/breadcrumb-nav.vue';
  import fullScreen from '../components/main-components/fullscreen.vue';
  import lockScreen from '../components/main-components/lockscreen/lockscreen.vue';
  import messageTip from '../components/main-components/message-tip.vue';
  import themeSwitch from '../components/main-components/theme-switch/theme-switch.vue';
  import Cookies from 'js-cookie';
  import util from '../libs/util.js';
  import PageName from '../constant/PageName';
  import * as Cache from '../cache/Cache';
  import * as BaseHttpRequestAPI from '../api/BaseHttpRequestAPI';

  export default {
    components: {
      shrinkableMenu,
      tagsPageOpened,
      breadcrumbNav,
      fullScreen,
      lockScreen,
      messageTip,
      themeSwitch
    },
    data () {
      return {
        shrink: false,
        userName: '',
        isFullScreen: false,
        openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
        isResetPwd: false,//是否显示修改密码弹窗
        //修改密码表单数据
        userInfo: {
          oldPassword:'',
          newPassword:'',
          confirmPassword:'',
        },
        //修改密码表单验证
        ruleInline: {
          oldPassword: [
            {required: true, message: '请输入原密码', trigger: 'blur'}
          ],
          newPassword: [
            { required: true, pattern:/^(?=.*\d)(?=.*[A-Za-z])[\x20-\x7e]{8,16}$/, message: '请输入新密码，必须包含字母、数字，可含有符号，长度8-16位', trigger: 'blur' }
          ],
          confirmPassword: [
            { required: true, pattern:/^(?=.*\d)(?=.*[A-Za-z])[\x20-\x7e]{8,16}$/, message: '请输入新密码，必须包含字母、数字，可含有符号，长度8-16位', trigger: 'blur' }
          ],
        },
      };
    },
    computed: {
      menuList () {
        return this.$store.state.app.menuList;
      },
      pageTagsList () {
        return this.$store.state.app.pageOpenedList; // 打开的页面的页面对象
      },
      currentPath () {
        return this.$store.state.app.currentPath; // 当前面包屑数组
      },
      avatorPath () {
        return require('../assets/images/defaultHead.jpg');
      },
      cachePage () {
        return this.$store.state.app.cachePage;
      },
      lang () {
        return this.$store.state.app.lang;
      },
      menuTheme () {
        return this.$store.state.app.menuTheme;
      },
      mesCount () {
        return this.$store.state.app.messageCount;
      }
    },
    methods: {
      init () {
        let pathArr = util.setCurrentPath(this, this.$route.name);
        this.$store.commit('updateMenulist');
        if (pathArr.length >= 2) {
          this.$store.commit('addOpenSubmenu', pathArr[1].name);
        }
        let userInfo = Cache.getUserInfo();
        global.token = userInfo.nbr;
        this.userName = userInfo.userName;
        let messageCount = 3;
        this.messageCount = messageCount.toString();
        this.checkTag(this.$route.name);
        this.$store.commit('setMessageCount', 3);

        this.asyncQueryPermissionList(userInfo.roleId);
      },
      toggleClick () {
        this.shrink = !this.shrink;
      },
      handleClickUserDropdown (name) {
        if (name === 'ownSpace') {
          util.openNewPage(this, 'ownspace_index');
          this.$router.push({
            name: 'ownspace_index'
          });
        } else if (name === 'loginout') {
          // 退出登录
          Cache.setUserInfo('');
          this.$store.commit('clearOpenedSubmenu');
          this.$router.push({
            name: PageName.PAGE_LOGIN
          });
        } else if (name === 'resetPwd') {
          //修改密码
          this.isResetPwd = true;
        }
      },
      checkTag (name) {
        let openpageHasTag = this.pageTagsList.some(item => {
          if (item.name === name) {
            return true;
          }
        });
        if (!openpageHasTag) { //  解决关闭当前标签后再点击回退按钮会退到当前页时没有标签的问题
          util.openNewPage(this, name, this.$route.params || {}, this.$route.query || {});
        }
      },
      handleSubmenuChange (val) {
        // console.log(val)
      },
      beforePush (name) {
        // if (name === 'accesstest_index') {
        //     return false;
        // } else {
        //     return true;
        // }
        return true;
      },
      fullscreenChange (isFullScreen) {
        // console.log(isFullScreen);
      },
      asyncQueryPermissionList(roleNbr){
        BaseHttpRequestAPI.queryPermissionList(roleNbr, (resp)=>{
          let permissions = resp.result.roleResourceRelationList ? resp.result.roleResourceRelationList : [];
          //设置权限
          Cache.setPermissions(permissions);
          this.$store.commit('updateMenulist');
        })
      },
      //修改密码弹窗确定
      onResetPwdModalOk () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.asyncResetPwd();
          }
        });
      },
      //修改密码
      asyncResetPwd(){
        BaseHttpRequestAPI.resetUserPasswordBySelf(this.userInfo.oldPassword,this.userInfo.newPassword,this.userInfo.confirmPassword, (resp) => {
          this.$Message.success('修改密码成功');
          //数据重置
          this.userInfo = {};
          this.isResetPwd = false;
          //退出需要重新登录
          Cache.setUserInfo('');
          Cache.setSsoSession('');
          Cache.setPermissions('');
          this.$store.commit('clearOpenedSubmenu');
          this.$router.push({
            name: PageName.PAGE_LOGIN
          });
        })
      },
      //修改密码弹窗取消
      onResetPwdModalCancel(){
        this.isResetPwd = false;
        //数据重置
        this.userInfo = {};
      },
    },
    watch: {
      '$route' (to) {
        global.currentPageName = to.name;
        this.$store.commit('setCurrentPageName', to.name);
        let pathArr = util.setCurrentPath(this, to.name);
        if (pathArr.length > 2) {
          this.$store.commit('addOpenSubmenu', pathArr[1].name);
        }
        this.checkTag(to.name);
        sessionStorage.currentPageName = to.name;
      },
      lang () {
        util.setCurrentPath(this, this.$route.name); // 在切换语言时用于刷新面包屑
      }
    },
    mounted () {
      this.init();
    },
    created () {
      // 显示打开的页面的列表
      this.$store.commit('setOpenedList');
    }
  };
</script>



// WEBPACK FOOTER //
// src/pages/Main.vue